import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select-plus';
import MapPropTypes from '../MapPropTypes';
import utils from '../../utils';
import SeatInput from './SeatInput';
import DurationInput from './DurationInput';
import strings from '../../strings';

export default class CartItem extends Component {
    static propTypes = {
        item: MapPropTypes.CartItemProps.isRequired,
        offer: MapPropTypes.OfferProps.isRequired,
        isPricingContinuous: PropTypes.bool.isRequired,
        hasOnlyWeeklyPricing: PropTypes.bool.isRequired,
        serverAliases: PropTypes.object,
        serversBySite: PropTypes.arrayOf(MapPropTypes.SiteProps).isRequired,
        myself: MapPropTypes.UserProps,
        removeItemFromCart: PropTypes.func.isRequired,
        updateMonthCount: PropTypes.func.isRequired,
        updateSeats: PropTypes.func.isRequired,
        updateServer: PropTypes.func.isRequired,
        updateStartDate: PropTypes.func.isRequired,
        updateDateRange: PropTypes.func.isRequired,
        updateWeekCount: PropTypes.func.isRequired,
        updateEndDate: PropTypes.func.isRequired,
        addItemToCart: PropTypes.func.isRequired,
        readyForaddToCart: PropTypes.bool,
        editCart: PropTypes.bool,
    };

    onServerChange(option) {
        const indices = option.value.split(',');
        const [siteIndex, serverIndex] = indices;
        this.props.updateServer(
            parseInt(siteIndex, 10),
            parseInt(serverIndex, 10)
        );
    }

    _selectValue() {
        const { siteIndex, serverIndex } = this.props.item;
        return `${siteIndex},${serverIndex}`;
    }

    _getOptions() {
        return this.props.serversBySite.map((site, siteIndex) => ({
            label: `${site.name} - ${site.mentorId}`,
            options: site.servers.map((server, serverIndex) => {
                const result = { value: `${siteIndex},${serverIndex}` };

                if (this.props.serverAliases[server.id]) {
                    result.label = this.props.serverAliases[server.id];
                } else {
                    const platform = server.platform
                        ? ` - ${server.platform.variant}`
                        : '';
                    result.label = `${server.mentorId}${platform}`;
                }

                return result;
            }),
        }));
    }

    render() {
        const soldTo = this.props.offer.account.soldTo;
        const usesEndDatePicker =
            this.props.offer.enterprise_deal ||
            utils.isDateRangeSoldTO(soldTo) ||
            this.props.offer.dailyPricingEnabled;
        const isDateRangeValid =  (
            this.props.item.startDate &&
            this.props.item.endDate &&
            moment(this.props.item.endDate).isAfter(moment(this.props.item.startDate))
        );

        return (
            <tr className="cart-item">
                <td>

                    <b className="display-block text-lg">
                        {this.props.item.pricing.product.name}
                    </b>
                    <b className="text-mute text-sm">
                        #{this.props.item.pricing.product.mentorId}
                    </b>
                </td>
                <td className="text-left">
                    <Select
                        className="site-server-input"
                        clearable={false}
                        onChange={(o) => this.onServerChange(o)}
                        value={this._selectValue()}
                        options={this._getOptions()}
                    />
                </td>
                <td className="text-center" width="108">
                    <SeatInput
                        seats={this.props.item.seats}
                        updateSeats={this.props.updateSeats}
                    />
                </td>
                <td className="text-center">
                    <DurationInput
                        monthCount={this.props.item.monthCount}
                        weekCount={this.props.item.weekCount}
                        maxMonths={
                            this.props.item.pricing.monthly.length > 0
                                ? Math.max(...this.props.item.pricing.monthly.map(m => m.amount))
                                : 0
                        }
                        minMonths={
                            this.props.item.pricing.monthly.length > 0
                                ? Math.min(...this.props.item.pricing.monthly.map(m => m.amount))
                                : 0
                        }
                        offerEnd={this.props.offer.validTo}
                        showWeeks={this.props.offer.weeklyPricingEnabled}
                        startDate={this.props.item.startDate}
                        endDate={this.props.item.endDate}
                        enterprise_deal={this.props.offer.enterprise_deal}
                        updateMonthCount={this.props.updateMonthCount}
                        updateWeekCount={this.props.updateWeekCount}
                        updateStartDate={this.props.updateStartDate}
                        updateDateRange={this.props.updateDateRange}
                        updateEndDate={this.props.updateEndDate}
                        isPricingContinuous={this.props.isPricingContinuous}
                        hasOnlyWeeklyPricing={this.props.hasOnlyWeeklyPricing}
                        prices={this.props.item.pricing}
                        soldto={this.props.offer.account.soldTo}
                        dailyPricingEnabled={this.props.offer.dailyPricingEnabled}
                    />
                </td>
                <td className="text-center">
                    <div className="price-indicator">
                        <b className="text-info text-lg">
                            {utils.formatPrice(this.props.item.seatCost)}
                        </b>
                        <span className="text-xs text-uppercase text-mute">
                            /{strings.seat}
                        </span>
                    </div>
                </td>
                <td className="text-center">
                    <div className="subtotal-indicator">
                        <b className="text-info text-lg">
                            {utils.formatPrice(this.props.item.subtotal)}
                        </b>
                    </div>
                </td>
                <td className="text-right">
                    <div className="button-group">
                        <button
                            type="button"
                            className="add-to-cart-text"
                            aria-label={strings.addToCart}
                            hidden={
                                this.props.item.addedToCart ||
                                (usesEndDatePicker && !isDateRangeValid) ||
                                (this.props.item.monthCount <= 0 && this.props.item.weekCount <= 0)
                            }
                            onClick={() => this.props.addItemToCart()}
                        >
                            {strings.addToCart}
                        </button>
                        <div className={`cart-item-remove ${this.props.item.addedToCart ? 'adjusted' : ''}`}>
                            <button
                                type="button"
                                className="close cart-remove-icon"
                                aria-label={strings.remove}
                                onClick={() => this.props.removeItemFromCart()}>
                                <span className="text-danger remove-text" >
                                    {strings.remove}
                                </span>
                                <svg className="remove-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="12" fill="red" />
                                    <line x1="8" y1="8" x2="16" y2="16" stroke="white" strokeWidth="2" />
                                    <line x1="16" y1="8" x2="8" y2="16" stroke="white" strokeWidth="2" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Cart/CartItem.jsx